import { InfoCircleOutlined } from '@ant-design/icons';
import { Tabs, Tooltip } from 'antd';
import FilesView from './files';
import IngestionConfigurationTab from './ingestionConfiguration';
import JobTab from './jobTab';
import React from 'react';
import Schedules from './schedules';

const { TabPane } = Tabs;

const IngestionDashboardTabs = props => {
  const { clientDisApi, client } = props;

  return (
    <Tabs defaultActiveKey="1">
      <TabPane
        tab={
          <>
            <Tooltip
              placement="bottom"
              overlayClassName="extra-wide"
              title="Manage and schedule ingestion runs."
            >
              <InfoCircleOutlined />
            </Tooltip>
            Schedules
          </>
        }
        key="1"
      >
        <Schedules selectedClient={client} />
      </TabPane>
      <TabPane
        tab={
          <>
            <Tooltip
              placement="bottom"
              overlayClassName="extra-wide"
              title="View information on files that have been uploaded for ingestion."
            >
              <InfoCircleOutlined />
            </Tooltip>
            Jobs
          </>
        }
        key="2"
      >
        <JobTab selectedClient={client} />
      </TabPane>
      <TabPane
        tab={
          <>
            <Tooltip
              placement="bottom"
              overlayClassName="extra-wide"
              title="View information on files that have been uploaded for ingestion."
            >
              <InfoCircleOutlined />
            </Tooltip>
            Files
          </>
        }
        key="3"
      >
        <FilesView clientDisApi={clientDisApi} selectedClient={client} />
      </TabPane>
      {client.use_multitenant_config && (
        <TabPane
          tab={
            <>
              <Tooltip
                placement="bottom"
                overlayClassName="extra-wide"
                title="Configure general ingestion settings for the client."
              >
                <InfoCircleOutlined />
              </Tooltip>
              Configuration
            </>
          }
          key="4"
        >
          <IngestionConfigurationTab selectedClient={client} />
        </TabPane>
      )}
    </Tabs>
  );
};

export default IngestionDashboardTabs;
